import { useNavigate } from 'react-router-dom'
import TableFilter from './tableFilter'
import { useEffect } from 'react'
import ExportButton from '../../common/ExportButton'
import { appGetAllFacility } from '../../store/facilities'
import { facilityExportColumns } from '../../config/exportColumns/facilityExportColumns'
import { useDispatch } from 'react-redux'

function Facility() {
	const dispatch = useDispatch()
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	return (
		<>
			<div className="content-wrapper">
				<div
					className="content-heading d-flex
                          justify-content-between"
				>
					<div>Facility</div>
					<div>
						<ExportButton
							fetchAction={params =>
								dispatch(
									appGetAllFacility({
										...params,
										sanstha: sansthaId || permissionOfSanstha,
										loading: false,
									}),
								)
							}
							filters={{}}
							columns={facilityExportColumns}
							fileName="Facility_List"
							sheetName="Facilities"
							buttonText="Export Facilities"
							buttonClass="btn btn-success mr-2"
						/>
					</div>
				</div>
				<TableFilter />
			</div>
		</>
	)
}

export default Facility
